<template>
	<div>
		<div  class="head row">
			<h3  class="pl-3">Mailtemplates</h3>
		</div>
		<div class="mail-in-wrap">
			<table class="table table-responsive table-hover">
				<thead>
					<tr>
					<th></th>
					<th>Identifier</th>
					<th>Naam</th>
					<th>Onderwerp</th>
					<th>Verstuur</th>
					</tr>
				</thead>
				<thead>
					<tr>
					<th></th>
					<th><input type="text" @keyup="filter()" v-model="search.identifier" placeholder="Zoeken..." class="form-control"></th>
					<th><input type="text" @keyup="filter()" v-model="search.name" placeholder="Zoeken..." class="form-control"></th>
					<th><input type="text" @keyup="filter()" v-model="search.subject" placeholder="Zoeken..." class="form-control"></th>
					<th><input type="text" @keyup="filter()" v-model="search.settings" placeholder="Zoeken..." class="form-control"></th>
					</tr>
				</thead>
				<thead></thead>
				<tbody>
					<tr v-for="(emailtemp,index) in mailtemplates" :key="index">
					<td>
						<div class="btn-group">
							<a :href="'/settings/mailtemplates/'+emailtemp.id" class="btn btn-primary"><i class="fas fa-pencil-alt"></i></a>
							<a @click="deletetemp(emailtemp.id)" class="btn btn-danger"><i class="fa fa-trash"></i></a>
						</div>
					</td>
					<td>{{emailtemp.identifier}}</td>
					<td>{{emailtemp.name}}</td>
					<td>{{emailtemp.subject}}</td>
					<td>{{ getSetting(emailtemp.settings) }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
export default {
	name: 'index',
	components: {},
	computed:{},
	data () {
		return {
			mailtemplates:[],
			search :{}
		}
	},
	created(){
		this.$store.dispatch('get','/api/v1/mailtemplates')
		.then(data=>{
			console.log(data.data);
			this.mailtemplates=data.data.data;
		})
		.catch(error=>{
			console.log(error.request);
		});
	},
	methods:{
		getSetting(settings) {
			let settingValues = JSON.parse(settings).sent
			if(settingValues.direct == true && settingValues.daily == false) return 'Direct'
			else if(settingValues.daily == true && settingValues.direct == false) return 'Dagelijks'
			else return 'Nooit'
		},
		filter(){
			this.$store.dispatch('post',{
					details:{search:this.search},
					endpoint:'/api/v1/mailtemplates/filter'
				})
				.then(data=>{
					console.log(data.data);
					this.mailtemplates=data.data.data;
				})
				.catch(error=>{
					console.log(error.request);
				});
		},
		deletetemp(id){
			this.$store.dispatch('get','/api/v1/delete-mailtemplates/'+id)
			.then((data)=>{
				console.log(data);
			})
			.catch(error=>{
				console.log(error);
			});
			this.mailtemplates=this.mailtemplates.filter((d)=> d.id != id);
		}
	}
}
</script>

<style lang="css" scoped>
</style>
